<template>
	<div v-if="pages.length > 1" class="tabs">
		<ul>
			<li v-for="page in pages" :key="page.id">
				<router-link
					:to="page.link"
					:class="`gtm-${page.link.params.page}-tab`"
					>{{ page.name }}</router-link
				>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "LayoutPageNavigation",
	props: {
		pages: {
			type: Array,
			default: () => []
		}
	},
	computed: {},
	methods: {}
};
</script>

<style lang="scss" scoped>
.tabs li a {
	// border-bottom-width: 2px;
	// border-bottom-color: transparent;
	// font-weight: 600;

	// &:hover {
	// 	border-bottom-color: black;
	// }

	// &.router-link-exact-active {
	// 	border-bottom: 2px solid #3273dc;
	// 	color: #3273dc;
	// }
}
</style>
